import React from 'react';
import * as S from './Podcast.styles';

interface Props {
  value: {
    src: string;
    title: string;
  };
}

export const PodcastBlock = ({ value, value: { src, title } }: Props) => {
  if (src) {
    return <S.StyledIframe width="100%" title={title} src={src} />;
  }
  return <pre>{JSON.stringify(value, null, 2)}</pre>;
};
